import React from 'react';
import SiteHeader from "../../../components/Template/SiteHeader";
import SignUpBanner from "../../../components/Banner/SignUpBanner";
import SearchAddress from "./SearchAddress";
import Footer from "../../../components/Template/Footer";

const SearchAddressWrapper: React.FC = () => {
  return (
      <div className="min-h-screen flex flex-col relative">
        <section className="bg-center bg-cover bg-no-repeat" style={{backgroundImage: "url('/images/background-header.jpg')"}}>
          <SiteHeader/>
          <SignUpBanner/>
        </section>
        <section className="grow">
          <SearchAddress/>
        </section>
        <Footer/>
      </div>
  );
};

export default SearchAddressWrapper;
